import { render, staticRenderFns } from "./VigenciasForm.vue?vue&type=template&id=435d0137&scoped=true"
import script from "./VigenciasForm.vue?vue&type=script&lang=js"
export * from "./VigenciasForm.vue?vue&type=script&lang=js"
import style0 from "./VigenciasForm.vue?vue&type=style&index=0&id=435d0137&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "435d0137",
  null
  
)

export default component.exports